const enum HeaderType {
  Name,
  Memo,
  Time,
  BatteryLifeRessetedAt,
  Status,
}

export default HeaderType
